import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterCRRAUpdateModel } from 'src/Models/CRRAUpdateModel';

@Injectable({
  providedIn: 'root'
})
export class CrraUpdatesMasterService {

  AppUrl = '';
  filterUpdateModel = new FilterCRRAUpdateModel();
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }


  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllUpdate(TokenKey: string, PageNumber: number, PageSize: number, stateID: string, orderBy: string): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      stateID,
      orderBy,
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRAUpdateMaster/GetAllUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRAUpdateMaster/UpdateAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUpdateById(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRAUpdateMaster/GetUpdateById/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteUpdate(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRAUpdateMaster/DeleteUpdate/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdateByUser(TokenKey: string, PageNumber: number, PageSize: number, stateID: string, fromDate: string, toDate: string, orderBy: string, userId: number, isFavorite: number): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      stateID,
      orderBy,
      fromDate,
      toDate,
      userId,
      isFavorite,
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRAUpdateMaster/GetAllUpdateByUser';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
  // ExportUpdates(TokenKey: string, PageNumber: number, PageSize: number, stateID: string, orderBy: string): Observable<any> {
  //   this.filterUpdateModel = {
  //     pageNumber: PageNumber,
  //     pageSize: PageSize,
  //     stateID: stateID,
  //     orderBy: orderBy,
  //   }
  //   this.setAPIUrl();
  //   let URL = this.AppUrl + 'api/CRRUpdateMaster/ExportUpdates';
  //   const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
  //   return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
  //     .pipe(catchError(this.handleError));
  // }

  GetCRRANotificationHistory(userlink: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFA_911_DownloadHistory/GetCRRANotificationHistory/' + userlink;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdateV2(TokenKey: string, PageNumber: number, PageSize: number, stateID: string, orderBy: string,_IsExport:boolean): Observable<any> {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      stateID,
      orderBy,
      IsExport:_IsExport
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRAUpdateMaster/V2/GetAllUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
